
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/columns/ranking",
      function () {
        return require("private-next-pages/columns/ranking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/columns/ranking"])
      });
    }
  